module.exports = __webpack_public_path__ + "static/media/route-highway.b0ce4250.svg";